export const SENTRY_ENVIRONMENTS = ["development", "qa", "production"] as const;
export type SentryEnvironment = (typeof SENTRY_ENVIRONMENTS)[number];
